// img-productos.js - VERSIÓN CORREGIDA Y OPTIMIZADA

// BANCAS
import BANCA1 from './img/muebles-productos/BANCAS/BANCA1blanca.png';
import BANCA2 from './img/muebles-productos/BANCAS/BANCA1negra.png';
import BANCA3 from './img/muebles-productos/BANCAS/BANCA2blanca.png';
import BANCA4 from './img/muebles-productos/BANCAS/BANCA2negra.png';
import BANCA5 from './img/muebles-productos/BANCAS/BANCA3blanca.png';
import BANCA6 from './img/muebles-productos/BANCAS/BANCA3negra.png';
import BANCA7 from './img/muebles-productos/BANCAS/BANCA4blanca.png';
import BANCA8 from './img/muebles-productos/BANCAS/BANCA4negra.png';
import BANCA9 from './img/muebles-productos/BANCAS/BANCA5blanca.png';
import BANCA10 from './img/muebles-productos/BANCAS/BANCA5negra.png';
import BANCA11 from './img/muebles-productos/BANCAS/BANCA6blanca.png';
import BANCA12 from './img/muebles-productos/BANCAS/BANCA6negra.png';

// BANQUETAS
import BANQUETA1 from './img/muebles-productos/BANQUETAS/BANQUETA1blanca.png';
import BANQUETA2 from './img/muebles-productos/BANQUETAS/BANQUETA1blanca_persp.png';
import BANQUETA3 from './img/muebles-productos/BANQUETAS/BANQUETA1negra.png';
import BANQUETA4 from './img/muebles-productos/BANQUETAS/BANQUETA1negra_persp.png';
import BANQUETA5 from './img/muebles-productos/BANQUETAS/BANQUETA2blanca.png';
import BANQUETA6 from './img/muebles-productos/BANQUETAS/BANQUETA2blanca_perp.png';
import BANQUETA7 from './img/muebles-productos/BANQUETAS/BANQUETA2negra.png';
import BANQUETA8 from './img/muebles-productos/BANQUETAS/BANQUETA2negra_persp.png';
import BANQUETA9 from './img/muebles-productos/BANQUETAS/BANQUETA3blanca.png';
import BANQUETA10 from './img/muebles-productos/BANQUETAS/BANQUETA3negra.png';
import BANQUETA11 from './img/muebles-productos/BANQUETAS/BANQUETA4blanca.png';
import BANQUETA12 from './img/muebles-productos/BANQUETAS/BANQUETA4negra.png';

// SILLAS
import SILLA1 from './img/muebles-productos/SILLAS/SILLA1-blanca.png';
import SILLA2 from './img/muebles-productos/SILLAS/SILLA1-negra.png';
import SILLA3 from './img/muebles-productos/SILLAS/SILLA2-blanca.png';
import SILLA4 from './img/muebles-productos/SILLAS/SILLA2-negra.png';
import SILLA5 from './img/muebles-productos/SILLAS/SILLA3-blanca.png';
import SILLA6 from './img/muebles-productos/SILLAS/SILLA3-negra.png';
import SILLA7 from './img/muebles-productos/SILLAS/SILLA4-blanca.png';
import SILLA8 from './img/muebles-productos/SILLAS/SILLA4-negra.png';
import SILLA9 from './img/muebles-productos/SILLAS/SILLA5-blanca.png';
import SILLA10 from './img/muebles-productos/SILLAS/SILLA5-negra.png';
import SILLA11 from './img/muebles-productos/SILLAS/SILLA6-blanca.png';
import SILLA12 from './img/muebles-productos/SILLAS/SILLA6-negra.png';

// ESQUINEROS
import ESQUINERO1 from './img/muebles-productos/ESQUINEROS/ESQUINERO1-3.png';
import ESQUINERO2 from './img/muebles-productos/ESQUINEROS/ESQUINERO1-3.1.png';
import ESQUINERO3 from './img/muebles-productos/ESQUINEROS/ESQUINERO2-4.png';
import ESQUINERO4 from './img/muebles-productos/ESQUINEROS/ESQUINERO2-4.1.png';
import ESQUINERO5 from './img/muebles-productos/ESQUINEROS/ESQUINERO4-5.png';
import ESQUINERO6 from './img/muebles-productos/ESQUINEROS/ESQUINERO4-5.1.png';
import ESQUINERO7 from './img/muebles-productos/ESQUINEROS/ESQUINERO5-6.png';
import ESQUINERO8 from './img/muebles-productos/ESQUINEROS/ESQUINERO5-6.1.png';
import ESQUINERO9 from './img/muebles-productos/ESQUINEROS/ESQUINERO5-6.2.png';
import ESQUINERO10 from './img/muebles-productos/ESQUINEROS/ESQUINERO5-6.3.png';
import ESQUINERO11 from './img/muebles-productos/ESQUINEROS/ESQUINERO5-6.4.png';
import ESQUINERO12 from './img/muebles-productos/ESQUINEROS/ESQUINERO5-6.4.png';

// BEBERO
import BEBERO1 from './img/muebles-productos/BEBERO/BEBERO1blanco.png';
import BEBERO2 from './img/muebles-productos/BEBERO/BEBERO1blanco_persp.png';
import BEBERO3 from './img/muebles-productos/BEBERO/BEBERO2negro.png';
import BEBERO4 from './img/muebles-productos/BEBERO/BEBERO2negro_persp.png';

// FRUTEROS
import FRUTERO1 from './img/muebles-productos/FRUTEROS/FRUTERO1-3rep-blanco.png';
import FRUTERO2 from './img/muebles-productos/FRUTEROS/FRUTERO1-3rep-blanco-persp.png';
import FRUTERO3 from './img/muebles-productos/FRUTEROS/FRUTERO2-3rep-negro.png';
import FRUTERO4 from './img/muebles-productos/FRUTEROS/FRUTERO2-3rep-negro-persp.png';
import FRUTERO5 from './img/muebles-productos/FRUTEROS/FRUTERO3-4rep-blanco.png';
import FRUTERO6 from './img/muebles-productos/FRUTEROS/FRUTERO3-4rep-blanco-persp.png';
import FRUTERO7 from './img/muebles-productos/FRUTEROS/FRUTERO3-4rep-negro.png';
import FRUTERO8 from './img/muebles-productos/FRUTEROS/FRUTERO2-3rep-negro-persp.png';

// MESAS
import MESA1 from './img/muebles-productos/MESAS/MESA1-blanca.png';
import MESA2 from './img/muebles-productos/MESAS/MESA1-blanca-persp.png';
import MESA3 from './img/muebles-productos/MESAS/MESA1-negra.png';
import MESA4 from './img/muebles-productos/MESAS/MESA2-parrilla-blanca.png';
import MESA5 from './img/muebles-productos/MESAS/MESA2-parrilla-blanca-persp.png';
import MESA6 from './img/muebles-productos/MESAS/MESA2-parrilla-negra.png';
import MESA7 from './img/muebles-productos/MESAS/MESA3-blanca.png';
import MESA8 from './img/muebles-productos/MESAS/MESA3-blanca-persp.png';
import MESA9 from './img/muebles-productos/MESAS/MESA3-negra.png';
import MESA10 from './img/muebles-productos/MESAS/MESA4-angulo-blanca.png';
import MESA11 from './img/muebles-productos/MESAS/MESA4-angulo-blanca-persp.png';
import MESA12 from './img/muebles-productos/MESAS/MESA4-angulo-negra.png';

// SILLA DE NIÑO
import SILLA_NINO1 from './img/muebles-productos/SILLADENIÑO/SILLA_NINO1-blanca.png';
import SILLA_NINO2 from './img/muebles-productos/SILLADENIÑO/SILLA_NINO1-blanca-persp.png';
import SILLA_NINO3 from './img/muebles-productos/SILLADENIÑO/SILLA_NINO1-negra.png';
import SILLA_NINO4 from './img/muebles-productos/SILLADENIÑO/SILLA_NINO1-negra-persp.png';
import SILLA_NINO5 from './img/muebles-productos/SILLADENIÑO/SILLA_NINO2-blanca.png';
import SILLA_NINO6 from './img/muebles-productos/SILLADENIÑO/SILLA_NINO2-blanca-persp.png';
import SILLA_NINO7 from './img/muebles-productos/SILLADENIÑO/SILLA_NINO2-negra.png';
import SILLA_NINO8 from './img/muebles-productos/SILLADENIÑO/SILLA_NINO2-negra-persp.png';

// TABURETE
import TABURETE1 from './img/muebles-productos/TABURETE/TABURETE1-blanco.png';
import TABURETE2 from './img/muebles-productos/TABURETE/TABURETE1-negro.png';
import TABURETE3 from './img/muebles-productos/TABURETE/TABURETE1-negro-persp.png';
import TABURETE4 from './img/muebles-productos/TABURETE/TABURETE2-blanco-persp.png';
import TABURETE5 from './img/muebles-productos/TABURETE/TABURETE2blanco.png';
import TABURETE6 from './img/muebles-productos/TABURETE/TABURETE2-negro-persp.png';
import TABURETE7 from './img/muebles-productos/TABURETE/TABURETE3-blanco.png';
import TABURETE8 from './img/muebles-productos/TABURETE/TABURETE3-blanco-persp.png';
import TABURETE9 from './img/muebles-productos/TABURETE/TABURETE3-negro.png';
import TABURETE10 from './img/muebles-productos/TABURETE/TABURETE4-blanco.png';
import TABURETE11 from './img/muebles-productos/TABURETE/TABURETE4-negro.png';
import TABURETE12 from './img/muebles-productos/TABURETE/TABURETE4-blanco-persp.png';

// TABURETE CON ESPALDAR
import TABURETE_ESPALDAR1 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR1-blanco.png';
import TABURETE_ESPALDAR2 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR1-blanco-persp.png';
import TABURETE_ESPALDAR3 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR1-negro.png';
import TABURETE_ESPALDAR4 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR2-blanco.png';
import TABURETE_ESPALDAR5 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR2-blanco-persp.png';
import TABURETE_ESPALDAR6 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR3-blanco.png';
import TABURETE_ESPALDAR7 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR3-negro.png';
import TABURETE_ESPALDAR8 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR3-blanco-persp.png';
import TABURETE_ESPALDAR9 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR4-negro.png';
import TABURETE_ESPALDAR10 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR4-negro-persp.png';
import TABURETE_ESPALDAR11 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR5-negro.png';
import TABURETE_ESPALDAR12 from './img/muebles-productos/TABURETE_ESPALDAR/TABURETE_ESPALDAR5-negro-persp.png';

// MODULARES 
import MODULAR1 from "./img/muebles-productos/MODULARES/MODULAR1.1.png";
import MODULAR2 from "./img/muebles-productos/MODULARES/MODULAR1.2.png";
import MODULAR3 from "./img/muebles-productos/MODULARES/MODULAR1.3.png";
import MODULAR4 from "./img/muebles-productos/MODULARES/MODULAR2.1.png";
import MODULAR5 from "./img/muebles-productos/MODULARES/MODULAR2.2.png";
import MODULAR6 from "./img/muebles-productos/MODULARES/MODULAR2.3.png";
import MODULAR7 from "./img/muebles-productos/MODULARES/MODULAR3.1.png";
import MODULAR8 from "./img/muebles-productos/MODULARES/MODULAR3.2.png";
import MODULAR9 from "./img/muebles-productos/MODULARES/MODULAR3.3.png";
import MODULAR10 from "./img/muebles-productos/MODULARES/MODULAR4.1.png";
import MODULAR11 from "./img/muebles-productos/MODULARES/MODULAR4.2.png";
import MODULAR12 from "./img/muebles-productos/MODULARES/MODULAR4.3.png";

// PERCHEROS
import PERCHERO1 from "./img/muebles-productos/PERCHERO/PERCHERO1.png";
import PERCHERO2 from "./img/muebles-productos/PERCHERO/PERCHERO2.png";
import PERCHERO3 from "./img/muebles-productos/PERCHERO/PERCHERO3.png";

// EXTRAS - Nuevos productos
import ASERRIN1 from './img/aserrin.jpeg';
import TABLERO1 from './img/tablero.jpeg';
import TARUGO1 from './img/tarugo.jpeg';
import MADERA_PINO1 from './img/madera-pino.jpeg';

// Cache optimizado para imágenes precargadas
const imageCache = new Map();
const preloadQueue = [];

// Función optimizada para precargar imágenes críticas
const precargarImagenesCriticas = () => {
  const imagenesCriticas = [
    BANCA1, BANCA2, SILLA1, SILLA2, MESA1, MESA2,
    ESQUINERO1, FRUTERO1, BANQUETA1, MODULAR1, PERCHERO1
  ];
  
  imagenesCriticas.forEach((imagen, index) => {
    if (!imageCache.has(`critical-${index}`)) {
      const img = new Image();
      img.src = imagen;
      img.onload = () => {
        imageCache.set(`critical-${index}`, imagen);
      };
    }
  });
};

// Precarga por lotes para mejor performance
const precargarLote = (imagenes, loteId) => {
  imagenes.forEach((imagen, index) => {
    if (imagen && !imageCache.has(`${loteId}-${index}`)) {
      const img = new Image();
      img.src = imagen;
      img.onload = () => {
        imageCache.set(`${loteId}-${index}`, imagen);
      };
    }
  });
};

// Ejecutar precarga inmediatamente
precargarImagenesCriticas();

// Mapeo CORREGIDO de todas las imágenes para productos
export const todasLasImagenes = {
  // CATEGORÍAS PRINCIPALES - NOMBRES CORREGIDOS
  'BANCAS': [
    BANCA1, BANCA2, BANCA3, BANCA4, BANCA5, BANCA6,
    BANCA7, BANCA8, BANCA9, BANCA10, BANCA11, BANCA12
  ],
  'BANQUETAS': [ // CORREGIDO: 'BANQUETAS' en lugar de 'BANQUETA'
    BANQUETA1, BANQUETA2, BANQUETA3, BANQUETA4, BANQUETA5, BANQUETA6,
    BANQUETA7, BANQUETA8, BANQUETA9, BANQUETA10, BANQUETA11, BANQUETA12
  ],
  'SILLAS': [ // CORREGIDO: 'SILLAS' en lugar de 'SILLA RECTA ENREJILLADA'
    SILLA1, SILLA2, SILLA3, SILLA4, SILLA5, SILLA6,
    SILLA7, SILLA8, SILLA9, SILLA10, SILLA11, SILLA12
  ],
  'ESQUINEROS': [ // CORREGIDO: 'ESQUINEROS' en lugar de 'ESQUINERO 3 REPISAS'
    ESQUINERO1, ESQUINERO2, ESQUINERO3, ESQUINERO4, ESQUINERO5, ESQUINERO6,
    ESQUINERO7, ESQUINERO8, ESQUINERO9, ESQUINERO10, ESQUINERO11, ESQUINERO12
  ],
  'BEBEROS': [ // CORREGIDO: 'BEBEROS' en lugar de 'BEBERO'
    BEBERO1, BEBERO2, BEBERO3, BEBERO4
  ],
  'FRUTEROS': [ // CORREGIDO: 'FRUTEROS' en lugar de 'FRUTERO'
    FRUTERO1, FRUTERO2, FRUTERO3, FRUTERO4, FRUTERO5, FRUTERO6,
    FRUTERO7, FRUTERO8
  ],
  'MESAS': [ // CORREGIDO: 'MESAS' en lugar de 'MESA DE ANGULO'
    MESA1, MESA2, MESA3, MESA4, MESA5, MESA6,
    MESA7, MESA8, MESA9, MESA10, MESA11, MESA12
  ],
  'SILLAS DE NIÑO': [
    SILLA_NINO1, SILLA_NINO2, SILLA_NINO3, SILLA_NINO4, SILLA_NINO5, SILLA_NINO6,
    SILLA_NINO7, SILLA_NINO8
  ],
  'TABURETES': [ // CORREGIDO: 'TABURETES' en lugar de 'TABURETE'
    TABURETE1, TABURETE2, TABURETE3, TABURETE4, TABURETE5, TABURETE6,
    TABURETE7, TABURETE8, TABURETE9, TABURETE10, TABURETE11, TABURETE12
  ],
  'TABURETES CON ESPALDAR': [ // CORREGIDO: 'TABURETES CON ESPALDAR' en lugar de 'TABURETE ESPALDAR'
    TABURETE_ESPALDAR1, TABURETE_ESPALDAR2, TABURETE_ESPALDAR3, TABURETE_ESPALDAR4,
    TABURETE_ESPALDAR5, TABURETE_ESPALDAR6, TABURETE_ESPALDAR7, TABURETE_ESPALDAR8,
    TABURETE_ESPALDAR9, TABURETE_ESPALDAR10, TABURETE_ESPALDAR11, TABURETE_ESPALDAR12
  ],
  'MODULARES': [
    MODULAR1, MODULAR2, MODULAR3, MODULAR4, MODULAR5, MODULAR6,
    MODULAR7, MODULAR8, MODULAR9, MODULAR10, MODULAR11, MODULAR12
  ],
  'PERCHEROS': [
    PERCHERO1, PERCHERO2, PERCHERO3
  ],
  // NUEVOS PRODUCTOS - EXTRAS
  'MATERIALES': [ASERRIN1],
  'TABLERO ALISTONADO': [TABLERO1],
  'TARUGO ESTRIADO': [TARUGO1],
  'MADERA DE PINO SECA': [MADERA_PINO1]
};

// Precargar imágenes por categorías
Object.entries(todasLasImagenes).forEach(([categoria, imagenes]) => {
  precargarLote(imagenes, categoria);
});

// Exportar función optimizada para obtener imágenes con lazy loading
export const obtenerImagenConLazyLoading = (categoria, indice) => {
  const clave = `${categoria}-${indice}`;
  
  // Verificar en cache primero
  if (imageCache.has(clave)) {
    return imageCache.get(clave);
  }
  
  const imagen = todasLasImagenes[categoria]?.[indice];
  
  // Precargar si no está en cache
  if (imagen && !imageCache.has(clave)) {
    const img = new Image();
    img.src = imagen;
    img.onload = () => {
      imageCache.set(clave, imagen);
    };
  }
  
  return imagen;
};

// Función para precargar categoría completa
export const precargarCategoria = (categoria) => {
  const imagenes = todasLasImagenes[categoria] || [];
  precargarLote(imagenes, categoria);
};

export default todasLasImagenes;